var map = {
	"./3d-cube-scan.svg": 97905,
	"./3d-rotate.svg": 27835,
	"./3d-square.svg": 96507,
	"./3dcube.svg": 66170,
	"./DocumentList.svg": 34739,
	"./SealCheck.svg": 43525,
	"./Warning.svg": 53152,
	"./WarningCircle.svg": 14404,
	"./add-circle.svg": 37714,
	"./add-square.svg": 84919,
	"./add.svg": 73733,
	"./archive-add.svg": 95404,
	"./archive-book.svg": 98128,
	"./archive-minus.svg": 72165,
	"./archive-slash.svg": 50366,
	"./archive-tick.svg": 23372,
	"./archive.svg": 71214,
	"./arrange-circle-2.svg": 81736,
	"./arrange-circle.svg": 36897,
	"./arrange-square-horizontal.svg": 86817,
	"./arrange-square-vertical.svg": 20743,
	"./arrow-2-horizontal.svg": 1415,
	"./arrow-2-vertical.svg": 89301,
	"./arrow-bottom-3.svg": 45241,
	"./arrow-circle-down.svg": 30645,
	"./arrow-circle-left.svg": 8014,
	"./arrow-circle-right.svg": 80365,
	"./arrow-down-2.svg": 68625,
	"./arrow-down-circle-2.svg": 54992,
	"./arrow-down.svg": 19116,
	"./arrow-left-2.svg": 51870,
	"./arrow-left-3.svg": 71919,
	"./arrow-left-circle-2.svg": 83765,
	"./arrow-left.svg": 55771,
	"./arrow-right-2.svg": 41559,
	"./arrow-right-3.svg": 95110,
	"./arrow-right-circle-2.svg": 49854,
	"./arrow-right.svg": 31646,
	"./arrow-square-down.svg": 76090,
	"./arrow-square-left.svg": 77841,
	"./arrow-square-right.svg": 828,
	"./arrow-square-up.svg": 37961,
	"./arrow-square.svg": 14477,
	"./arrow-swap-horizontal.svg": 95746,
	"./arrow-swap-vertical.svg": 61680,
	"./arrow-up-2.svg": 22002,
	"./arrow-up-3.svg": 55043,
	"./arrow-up-circle-2.svg": 40473,
	"./arrow-up-circle.svg": 84260,
	"./arrow-up.svg": 28839,
	"./arrow.svg": 26407,
	"./autobrightness.svg": 86800,
	"./back-square.svg": 79591,
	"./battery-1.svg": 6613,
	"./battery-2.svg": 49014,
	"./battery-charging.svg": 76929,
	"./battery-disable.svg": 60088,
	"./battery-empty.svg": 60791,
	"./battery-full.svg": 59947,
	"./bill.svg": 30707,
	"./book-saved.svg": 20077,
	"./book-square.svg": 78241,
	"./box-2.svg": 57370,
	"./box-3.svg": 76427,
	"./box-add.svg": 20521,
	"./box-remove.svg": 91584,
	"./box-search.svg": 41924,
	"./box-tick.svg": 57359,
	"./box-time.svg": 89579,
	"./box.svg": 12383,
	"./broom.svg": 91555,
	"./bubble.svg": 94,
	"./cake.svg": 94264,
	"./calendar-2.svg": 12311,
	"./calendar-3.svg": 24774,
	"./calendar-add.svg": 77148,
	"./calendar-circle.svg": 98875,
	"./calendar-edit.svg": 29011,
	"./calendar-remove.svg": 21167,
	"./calendar-search.svg": 92619,
	"./calendar-tick.svg": 79548,
	"./calendar.svg": 87230,
	"./call-add.svg": 53330,
	"./call-calling.svg": 47983,
	"./call-incoming.svg": 40833,
	"./call-minus.svg": 96979,
	"./call-outgoing.svg": 79463,
	"./call-received.svg": 49196,
	"./call-remove.svg": 10445,
	"./call-slash.svg": 69316,
	"./call.svg": 27788,
	"./candle-2.svg": 58486,
	"./candle.svg": 17571,
	"./category-2.svg": 83833,
	"./category.svg": 94244,
	"./cd.svg": 6169,
	"./chart.svg": 3764,
	"./check.svg": 41476,
	"./chrome.svg": 24218,
	"./clipboard-close.svg": 47009,
	"./clipboard-export.svg": 29265,
	"./clipboard-import.svg": 91828,
	"./clipboard-text.svg": 93466,
	"./clipboard-tick.svg": 8132,
	"./clock.svg": 89126,
	"./close-2.svg": 32253,
	"./close-circle.svg": 18621,
	"./close-square.svg": 12304,
	"./coffee.svg": 41056,
	"./computing.svg": 91770,
	"./convert-3d-cube.svg": 79687,
	"./convert.svg": 45177,
	"./copyright.svg": 9283,
	"./creative-commons.svg": 10750,
	"./crown-2.svg": 44804,
	"./crown.svg": 14325,
	"./cup.svg": 71384,
	"./danger.svg": 76413,
	"./device-message.svg": 45992,
	"./diamonds.svg": 91163,
	"./direct-down.svg": 19156,
	"./direct-inbox.svg": 13944,
	"./direct-left.svg": 88531,
	"./direct-normal.svg": 8425,
	"./direct-notification.svg": 43429,
	"./direct-right.svg": 3798,
	"./direct-send.svg": 74786,
	"./direct-up.svg": 12207,
	"./direct.svg": 99087,
	"./directbox-default.svg": 29810,
	"./directbox-notif.svg": 22623,
	"./directbox-receive.svg": 73814,
	"./directbox-send.svg": 42277,
	"./discover-2.svg": 81968,
	"./discover.svg": 47673,
	"./document-cloud.svg": 31035,
	"./document-copy.svg": 99463,
	"./document-download.svg": 79808,
	"./document-favorite.svg": 31516,
	"./document-filter.svg": 27966,
	"./document-forward.svg": 66903,
	"./document-like.svg": 11345,
	"./document-normal.svg": 89041,
	"./document-previous.svg": 18863,
	"./document-sketch.svg": 1196,
	"./document-text 2.svg": 3823,
	"./document-text.svg": 40949,
	"./document-upload.svg": 58715,
	"./document.svg": 82199,
	"./draft.svg": 26509,
	"./drag.svg": 66778,
	"./edit-2.svg": 22933,
	"./edit.svg": 56408,
	"./emoji-happy.svg": 29563,
	"./emoji-normal.svg": 51294,
	"./emoji-sad.svg": 53477,
	"./export-2.svg": 64767,
	"./export-circle.svg": 97427,
	"./export-square.svg": 50930,
	"./export.svg": 25526,
	"./eye-slash.svg": 33615,
	"./eye.svg": 8675,
	"./filter-add.svg": 36896,
	"./filter-edit.svg": 6135,
	"./filter-remove.svg": 61539,
	"./filter-search.svg": 42943,
	"./filter-square.svg": 9414,
	"./filter-tick.svg": 41808,
	"./filter.svg": 17386,
	"./flag-2.svg": 39555,
	"./flag.svg": 12370,
	"./flash-circle.svg": 3415,
	"./flash-slash.svg": 30442,
	"./flash.svg": 5546,
	"./folder-dashed.svg": 54846,
	"./folder-double.svg": 28414,
	"./forward-square.svg": 22577,
	"./frame.svg": 17539,
	"./ghost.svg": 27721,
	"./glass.svg": 24192,
	"./global-edit.svg": 11266,
	"./global-refresh.svg": 89275,
	"./global-search.svg": 1598,
	"./global.svg": 52609,
	"./gps-slash.svg": 20824,
	"./gps.svg": 62848,
	"./grammerly.svg": 11238,
	"./group.svg": 87949,
	"./happyemoji.svg": 62828,
	"./home-2.svg": 62384,
	"./home-wifi.svg": 71389,
	"./home.svg": 85689,
	"./import-2.svg": 87166,
	"./import-circle.svg": 59992,
	"./import-squeare.svg": 5284,
	"./import.svg": 97051,
	"./info-circle.svg": 55581,
	"./information.svg": 79382,
	"./instagram.svg": 87352,
	"./judge.svg": 58393,
	"./lamp-charge.svg": 4351,
	"./lamp-on.svg": 4788,
	"./lamp-slash.svg": 60954,
	"./lamp.svg": 19962,
	"./level.svg": 19982,
	"./link.svg": 12156,
	"./location-add.svg": 56035,
	"./location-cross.svg": 77070,
	"./location-minus.svg": 60330,
	"./location-slash.svg": 89685,
	"./location-tick.svg": 64389,
	"./location.svg": 15305,
	"./login-2.svg": 21678,
	"./login.svg": 84523,
	"./logout-2.svg": 42503,
	"./logout.svg": 25582,
	"./map-2.svg": 81159,
	"./map.svg": 6478,
	"./menu-2.svg": 97800,
	"./menu-board.svg": 25126,
	"./menu.svg": 88897,
	"./message-2.svg": 96768,
	"./message-add 2.svg": 73305,
	"./message-add.svg": 16931,
	"./message-circle.svg": 31078,
	"./message-edit.svg": 61018,
	"./message-favorite.svg": 69386,
	"./message-minus.svg": 28042,
	"./message-notif.svg": 4252,
	"./message-remove.svg": 29778,
	"./message-search.svg": 92950,
	"./message-square.svg": 5403,
	"./message-text-2.svg": 57766,
	"./message-text.svg": 95763,
	"./message-tick.svg": 25157,
	"./message-time.svg": 93329,
	"./message.svg": 23561,
	"./messages-2.svg": 40485,
	"./messages-3.svg": 85764,
	"./messages-4.svg": 47915,
	"./messages.svg": 59208,
	"./milk.svg": 37637,
	"./minus-cirlce.svg": 85463,
	"./minus-square.svg": 81060,
	"./minus.svg": 64628,
	"./mirror.svg": 24253,
	"./more-2.svg": 56138,
	"./more-circle.svg": 29388,
	"./more-square.svg": 73941,
	"./more.svg": 31663,
	"./mouse-circle.svg": 88730,
	"./mouse-square.svg": 98975,
	"./mouse.svg": 86925,
	"./note-2.svg": 16853,
	"./note-add.svg": 26854,
	"./note-favorite.svg": 70589,
	"./note-remove.svg": 23953,
	"./note-text.svg": 44984,
	"./note.svg": 45016,
	"./notification-bing.svg": 76736,
	"./notification-circle.svg": 20974,
	"./notification-favorite.svg": 95858,
	"./notification-square.svg": 65955,
	"./notification-status.svg": 43780,
	"./notification.svg": 9809,
	"./paper-double.svg": 71428,
	"./pen.svg": 84805,
	"./people.svg": 70781,
	"./pet.svg": 32495,
	"./phone.svg": 63656,
	"./picture-frame.svg": 60086,
	"./placeholder.svg": 66179,
	"./printer.svg": 2472,
	"./profile-2user.svg": 52167,
	"./profile-add.svg": 89461,
	"./profile-circle.svg": 16272,
	"./profile-delete.svg": 12485,
	"./profile-remove.svg": 3340,
	"./profile-tick.svg": 30475,
	"./profile.svg": 40243,
	"./radar-2.svg": 50037,
	"./radar.svg": 17592,
	"./ranking.svg": 50106,
	"./receipt-square.svg": 59587,
	"./receive-square-2.svg": 18152,
	"./receive-square.svg": 11265,
	"./received.svg": 45933,
	"./redo.svg": 73708,
	"./refresh-2.svg": 55252,
	"./refresh-circle.svg": 75282,
	"./refresh-left-square.svg": 50987,
	"./refresh-right-square.svg": 18356,
	"./refresh-square-2.svg": 28066,
	"./refresh.svg": 31397,
	"./repeat-circle.svg": 37950,
	"./repeat.svg": 27073,
	"./reserve.svg": 16300,
	"./rotate-left.svg": 64797,
	"./rotate-right.svg": 43168,
	"./route-square.svg": 50993,
	"./routing-2.svg": 73303,
	"./routing.svg": 11614,
	"./safe-home.svg": 20361,
	"./save-2.svg": 50166,
	"./save-add.svg": 91813,
	"./save-minus.svg": 69076,
	"./save-remove.svg": 76476,
	"./search.svg": 97680,
	"./security-time.svg": 91396,
	"./send-2.svg": 40615,
	"./send-3.svg": 1078,
	"./send-sqaure-2.svg": 10595,
	"./send-square.svg": 18314,
	"./send.svg": 21614,
	"./setting-2.svg": 17045,
	"./setting-3.svg": 44436,
	"./setting-4.svg": 54203,
	"./setting-5.svg": 93834,
	"./setting-6.svg": 85209,
	"./settings.svg": 19179,
	"./share.svg": 83029,
	"./signpost.svg": 1837,
	"./slash.svg": 34735,
	"./slider.svg": 74819,
	"./smart-home.svg": 28397,
	"./sms-edit.svg": 76792,
	"./sms-notification.svg": 91089,
	"./sms-search.svg": 82512,
	"./sms-star.svg": 64180,
	"./sms-tracking.svg": 21743,
	"./sms.svg": 79363,
	"./sort.svg": 73272,
	"./sound.svg": 85809,
	"./speedometer.svg": 59235,
	"./status.svg": 52978,
	"./sticker.svg": 68217,
	"./stickynote.svg": 36045,
	"./stop-watch.svg": 48102,
	"./story.svg": 9667,
	"./tag-cross.svg": 3379,
	"./tag-right.svg": 17581,
	"./tag-user.svg": 95656,
	"./task-square.svg": 65305,
	"./task.svg": 42259,
	"./tick-circle.svg": 81784,
	"./tick-square.svg": 53153,
	"./timer-pause.svg": 97102,
	"./timer-start.svg": 48156,
	"./timer.svg": 29767,
	"./toggle-off-circle.svg": 96905,
	"./toggle-off.svg": 16924,
	"./toggle-on-circle.svg": 37667,
	"./toggle-on.svg": 98662,
	"./trash.svg": 74498,
	"./tree.svg": 42492,
	"./triangle.svg": 86008,
	"./truck-go.svg": 8236,
	"./truck-remove.svg": 30662,
	"./truck-tick.svg": 15417,
	"./truck-time.svg": 66069,
	"./truck.svg": 78565,
	"./trush-square.svg": 626,
	"./undo.svg": 28854,
	"./uo-empty.svg": 90352,
	"./user-add.svg": 33103,
	"./user-cirlce-add.svg": 67886,
	"./user-edit.svg": 94806,
	"./user-minus.svg": 30238,
	"./user-octagon.svg": 83723,
	"./user-remove.svg": 93150,
	"./user-search.svg": 51682,
	"./user-square.svg": 67983,
	"./user-tag.svg": 53394,
	"./user-tick.svg": 81745,
	"./user.svg": 99709,
	"./verify.svg": 99035,
	"./warning-2.svg": 70701,
	"./weight.svg": 89212,
	"./wifi-square.svg": 30761,
	"./wifi.svg": 61507,
	"./wrench.svg": 99127,
	"./xlsx-excel-thumb.svg": 34128,
	"assets/icons/3d-cube-scan.svg": 97905,
	"assets/icons/3d-rotate.svg": 27835,
	"assets/icons/3d-square.svg": 96507,
	"assets/icons/3dcube.svg": 66170,
	"assets/icons/DocumentList.svg": 34739,
	"assets/icons/SealCheck.svg": 43525,
	"assets/icons/Warning.svg": 53152,
	"assets/icons/WarningCircle.svg": 14404,
	"assets/icons/add-circle.svg": 37714,
	"assets/icons/add-square.svg": 84919,
	"assets/icons/add.svg": 73733,
	"assets/icons/archive-add.svg": 95404,
	"assets/icons/archive-book.svg": 98128,
	"assets/icons/archive-minus.svg": 72165,
	"assets/icons/archive-slash.svg": 50366,
	"assets/icons/archive-tick.svg": 23372,
	"assets/icons/archive.svg": 71214,
	"assets/icons/arrange-circle-2.svg": 81736,
	"assets/icons/arrange-circle.svg": 36897,
	"assets/icons/arrange-square-horizontal.svg": 86817,
	"assets/icons/arrange-square-vertical.svg": 20743,
	"assets/icons/arrow-2-horizontal.svg": 1415,
	"assets/icons/arrow-2-vertical.svg": 89301,
	"assets/icons/arrow-bottom-3.svg": 45241,
	"assets/icons/arrow-circle-down.svg": 30645,
	"assets/icons/arrow-circle-left.svg": 8014,
	"assets/icons/arrow-circle-right.svg": 80365,
	"assets/icons/arrow-down-2.svg": 68625,
	"assets/icons/arrow-down-circle-2.svg": 54992,
	"assets/icons/arrow-down.svg": 19116,
	"assets/icons/arrow-left-2.svg": 51870,
	"assets/icons/arrow-left-3.svg": 71919,
	"assets/icons/arrow-left-circle-2.svg": 83765,
	"assets/icons/arrow-left.svg": 55771,
	"assets/icons/arrow-right-2.svg": 41559,
	"assets/icons/arrow-right-3.svg": 95110,
	"assets/icons/arrow-right-circle-2.svg": 49854,
	"assets/icons/arrow-right.svg": 31646,
	"assets/icons/arrow-square-down.svg": 76090,
	"assets/icons/arrow-square-left.svg": 77841,
	"assets/icons/arrow-square-right.svg": 828,
	"assets/icons/arrow-square-up.svg": 37961,
	"assets/icons/arrow-square.svg": 14477,
	"assets/icons/arrow-swap-horizontal.svg": 95746,
	"assets/icons/arrow-swap-vertical.svg": 61680,
	"assets/icons/arrow-up-2.svg": 22002,
	"assets/icons/arrow-up-3.svg": 55043,
	"assets/icons/arrow-up-circle-2.svg": 40473,
	"assets/icons/arrow-up-circle.svg": 84260,
	"assets/icons/arrow-up.svg": 28839,
	"assets/icons/arrow.svg": 26407,
	"assets/icons/autobrightness.svg": 86800,
	"assets/icons/back-square.svg": 79591,
	"assets/icons/battery-1.svg": 6613,
	"assets/icons/battery-2.svg": 49014,
	"assets/icons/battery-charging.svg": 76929,
	"assets/icons/battery-disable.svg": 60088,
	"assets/icons/battery-empty.svg": 60791,
	"assets/icons/battery-full.svg": 59947,
	"assets/icons/bill.svg": 30707,
	"assets/icons/book-saved.svg": 20077,
	"assets/icons/book-square.svg": 78241,
	"assets/icons/box-2.svg": 57370,
	"assets/icons/box-3.svg": 76427,
	"assets/icons/box-add.svg": 20521,
	"assets/icons/box-remove.svg": 91584,
	"assets/icons/box-search.svg": 41924,
	"assets/icons/box-tick.svg": 57359,
	"assets/icons/box-time.svg": 89579,
	"assets/icons/box.svg": 12383,
	"assets/icons/broom.svg": 91555,
	"assets/icons/bubble.svg": 94,
	"assets/icons/cake.svg": 94264,
	"assets/icons/calendar-2.svg": 12311,
	"assets/icons/calendar-3.svg": 24774,
	"assets/icons/calendar-add.svg": 77148,
	"assets/icons/calendar-circle.svg": 98875,
	"assets/icons/calendar-edit.svg": 29011,
	"assets/icons/calendar-remove.svg": 21167,
	"assets/icons/calendar-search.svg": 92619,
	"assets/icons/calendar-tick.svg": 79548,
	"assets/icons/calendar.svg": 87230,
	"assets/icons/call-add.svg": 53330,
	"assets/icons/call-calling.svg": 47983,
	"assets/icons/call-incoming.svg": 40833,
	"assets/icons/call-minus.svg": 96979,
	"assets/icons/call-outgoing.svg": 79463,
	"assets/icons/call-received.svg": 49196,
	"assets/icons/call-remove.svg": 10445,
	"assets/icons/call-slash.svg": 69316,
	"assets/icons/call.svg": 27788,
	"assets/icons/candle-2.svg": 58486,
	"assets/icons/candle.svg": 17571,
	"assets/icons/category-2.svg": 83833,
	"assets/icons/category.svg": 94244,
	"assets/icons/cd.svg": 6169,
	"assets/icons/chart.svg": 3764,
	"assets/icons/check.svg": 41476,
	"assets/icons/chrome.svg": 24218,
	"assets/icons/clipboard-close.svg": 47009,
	"assets/icons/clipboard-export.svg": 29265,
	"assets/icons/clipboard-import.svg": 91828,
	"assets/icons/clipboard-text.svg": 93466,
	"assets/icons/clipboard-tick.svg": 8132,
	"assets/icons/clock.svg": 89126,
	"assets/icons/close-2.svg": 32253,
	"assets/icons/close-circle.svg": 18621,
	"assets/icons/close-square.svg": 12304,
	"assets/icons/coffee.svg": 41056,
	"assets/icons/computing.svg": 91770,
	"assets/icons/convert-3d-cube.svg": 79687,
	"assets/icons/convert.svg": 45177,
	"assets/icons/copyright.svg": 9283,
	"assets/icons/creative-commons.svg": 10750,
	"assets/icons/crown-2.svg": 44804,
	"assets/icons/crown.svg": 14325,
	"assets/icons/cup.svg": 71384,
	"assets/icons/danger.svg": 76413,
	"assets/icons/device-message.svg": 45992,
	"assets/icons/diamonds.svg": 91163,
	"assets/icons/direct-down.svg": 19156,
	"assets/icons/direct-inbox.svg": 13944,
	"assets/icons/direct-left.svg": 88531,
	"assets/icons/direct-normal.svg": 8425,
	"assets/icons/direct-notification.svg": 43429,
	"assets/icons/direct-right.svg": 3798,
	"assets/icons/direct-send.svg": 74786,
	"assets/icons/direct-up.svg": 12207,
	"assets/icons/direct.svg": 99087,
	"assets/icons/directbox-default.svg": 29810,
	"assets/icons/directbox-notif.svg": 22623,
	"assets/icons/directbox-receive.svg": 73814,
	"assets/icons/directbox-send.svg": 42277,
	"assets/icons/discover-2.svg": 81968,
	"assets/icons/discover.svg": 47673,
	"assets/icons/document-cloud.svg": 31035,
	"assets/icons/document-copy.svg": 99463,
	"assets/icons/document-download.svg": 79808,
	"assets/icons/document-favorite.svg": 31516,
	"assets/icons/document-filter.svg": 27966,
	"assets/icons/document-forward.svg": 66903,
	"assets/icons/document-like.svg": 11345,
	"assets/icons/document-normal.svg": 89041,
	"assets/icons/document-previous.svg": 18863,
	"assets/icons/document-sketch.svg": 1196,
	"assets/icons/document-text 2.svg": 3823,
	"assets/icons/document-text.svg": 40949,
	"assets/icons/document-upload.svg": 58715,
	"assets/icons/document.svg": 82199,
	"assets/icons/draft.svg": 26509,
	"assets/icons/drag.svg": 66778,
	"assets/icons/edit-2.svg": 22933,
	"assets/icons/edit.svg": 56408,
	"assets/icons/emoji-happy.svg": 29563,
	"assets/icons/emoji-normal.svg": 51294,
	"assets/icons/emoji-sad.svg": 53477,
	"assets/icons/export-2.svg": 64767,
	"assets/icons/export-circle.svg": 97427,
	"assets/icons/export-square.svg": 50930,
	"assets/icons/export.svg": 25526,
	"assets/icons/eye-slash.svg": 33615,
	"assets/icons/eye.svg": 8675,
	"assets/icons/filter-add.svg": 36896,
	"assets/icons/filter-edit.svg": 6135,
	"assets/icons/filter-remove.svg": 61539,
	"assets/icons/filter-search.svg": 42943,
	"assets/icons/filter-square.svg": 9414,
	"assets/icons/filter-tick.svg": 41808,
	"assets/icons/filter.svg": 17386,
	"assets/icons/flag-2.svg": 39555,
	"assets/icons/flag.svg": 12370,
	"assets/icons/flash-circle.svg": 3415,
	"assets/icons/flash-slash.svg": 30442,
	"assets/icons/flash.svg": 5546,
	"assets/icons/folder-dashed.svg": 54846,
	"assets/icons/folder-double.svg": 28414,
	"assets/icons/forward-square.svg": 22577,
	"assets/icons/frame.svg": 17539,
	"assets/icons/ghost.svg": 27721,
	"assets/icons/glass.svg": 24192,
	"assets/icons/global-edit.svg": 11266,
	"assets/icons/global-refresh.svg": 89275,
	"assets/icons/global-search.svg": 1598,
	"assets/icons/global.svg": 52609,
	"assets/icons/gps-slash.svg": 20824,
	"assets/icons/gps.svg": 62848,
	"assets/icons/grammerly.svg": 11238,
	"assets/icons/group.svg": 87949,
	"assets/icons/happyemoji.svg": 62828,
	"assets/icons/home-2.svg": 62384,
	"assets/icons/home-wifi.svg": 71389,
	"assets/icons/home.svg": 85689,
	"assets/icons/import-2.svg": 87166,
	"assets/icons/import-circle.svg": 59992,
	"assets/icons/import-squeare.svg": 5284,
	"assets/icons/import.svg": 97051,
	"assets/icons/info-circle.svg": 55581,
	"assets/icons/information.svg": 79382,
	"assets/icons/instagram.svg": 87352,
	"assets/icons/judge.svg": 58393,
	"assets/icons/lamp-charge.svg": 4351,
	"assets/icons/lamp-on.svg": 4788,
	"assets/icons/lamp-slash.svg": 60954,
	"assets/icons/lamp.svg": 19962,
	"assets/icons/level.svg": 19982,
	"assets/icons/link.svg": 12156,
	"assets/icons/location-add.svg": 56035,
	"assets/icons/location-cross.svg": 77070,
	"assets/icons/location-minus.svg": 60330,
	"assets/icons/location-slash.svg": 89685,
	"assets/icons/location-tick.svg": 64389,
	"assets/icons/location.svg": 15305,
	"assets/icons/login-2.svg": 21678,
	"assets/icons/login.svg": 84523,
	"assets/icons/logout-2.svg": 42503,
	"assets/icons/logout.svg": 25582,
	"assets/icons/map-2.svg": 81159,
	"assets/icons/map.svg": 6478,
	"assets/icons/menu-2.svg": 97800,
	"assets/icons/menu-board.svg": 25126,
	"assets/icons/menu.svg": 88897,
	"assets/icons/message-2.svg": 96768,
	"assets/icons/message-add 2.svg": 73305,
	"assets/icons/message-add.svg": 16931,
	"assets/icons/message-circle.svg": 31078,
	"assets/icons/message-edit.svg": 61018,
	"assets/icons/message-favorite.svg": 69386,
	"assets/icons/message-minus.svg": 28042,
	"assets/icons/message-notif.svg": 4252,
	"assets/icons/message-remove.svg": 29778,
	"assets/icons/message-search.svg": 92950,
	"assets/icons/message-square.svg": 5403,
	"assets/icons/message-text-2.svg": 57766,
	"assets/icons/message-text.svg": 95763,
	"assets/icons/message-tick.svg": 25157,
	"assets/icons/message-time.svg": 93329,
	"assets/icons/message.svg": 23561,
	"assets/icons/messages-2.svg": 40485,
	"assets/icons/messages-3.svg": 85764,
	"assets/icons/messages-4.svg": 47915,
	"assets/icons/messages.svg": 59208,
	"assets/icons/milk.svg": 37637,
	"assets/icons/minus-cirlce.svg": 85463,
	"assets/icons/minus-square.svg": 81060,
	"assets/icons/minus.svg": 64628,
	"assets/icons/mirror.svg": 24253,
	"assets/icons/more-2.svg": 56138,
	"assets/icons/more-circle.svg": 29388,
	"assets/icons/more-square.svg": 73941,
	"assets/icons/more.svg": 31663,
	"assets/icons/mouse-circle.svg": 88730,
	"assets/icons/mouse-square.svg": 98975,
	"assets/icons/mouse.svg": 86925,
	"assets/icons/note-2.svg": 16853,
	"assets/icons/note-add.svg": 26854,
	"assets/icons/note-favorite.svg": 70589,
	"assets/icons/note-remove.svg": 23953,
	"assets/icons/note-text.svg": 44984,
	"assets/icons/note.svg": 45016,
	"assets/icons/notification-bing.svg": 76736,
	"assets/icons/notification-circle.svg": 20974,
	"assets/icons/notification-favorite.svg": 95858,
	"assets/icons/notification-square.svg": 65955,
	"assets/icons/notification-status.svg": 43780,
	"assets/icons/notification.svg": 9809,
	"assets/icons/paper-double.svg": 71428,
	"assets/icons/pen.svg": 84805,
	"assets/icons/people.svg": 70781,
	"assets/icons/pet.svg": 32495,
	"assets/icons/phone.svg": 63656,
	"assets/icons/picture-frame.svg": 60086,
	"assets/icons/placeholder.svg": 66179,
	"assets/icons/printer.svg": 2472,
	"assets/icons/profile-2user.svg": 52167,
	"assets/icons/profile-add.svg": 89461,
	"assets/icons/profile-circle.svg": 16272,
	"assets/icons/profile-delete.svg": 12485,
	"assets/icons/profile-remove.svg": 3340,
	"assets/icons/profile-tick.svg": 30475,
	"assets/icons/profile.svg": 40243,
	"assets/icons/radar-2.svg": 50037,
	"assets/icons/radar.svg": 17592,
	"assets/icons/ranking.svg": 50106,
	"assets/icons/receipt-square.svg": 59587,
	"assets/icons/receive-square-2.svg": 18152,
	"assets/icons/receive-square.svg": 11265,
	"assets/icons/received.svg": 45933,
	"assets/icons/redo.svg": 73708,
	"assets/icons/refresh-2.svg": 55252,
	"assets/icons/refresh-circle.svg": 75282,
	"assets/icons/refresh-left-square.svg": 50987,
	"assets/icons/refresh-right-square.svg": 18356,
	"assets/icons/refresh-square-2.svg": 28066,
	"assets/icons/refresh.svg": 31397,
	"assets/icons/repeat-circle.svg": 37950,
	"assets/icons/repeat.svg": 27073,
	"assets/icons/reserve.svg": 16300,
	"assets/icons/rotate-left.svg": 64797,
	"assets/icons/rotate-right.svg": 43168,
	"assets/icons/route-square.svg": 50993,
	"assets/icons/routing-2.svg": 73303,
	"assets/icons/routing.svg": 11614,
	"assets/icons/safe-home.svg": 20361,
	"assets/icons/save-2.svg": 50166,
	"assets/icons/save-add.svg": 91813,
	"assets/icons/save-minus.svg": 69076,
	"assets/icons/save-remove.svg": 76476,
	"assets/icons/search.svg": 97680,
	"assets/icons/security-time.svg": 91396,
	"assets/icons/send-2.svg": 40615,
	"assets/icons/send-3.svg": 1078,
	"assets/icons/send-sqaure-2.svg": 10595,
	"assets/icons/send-square.svg": 18314,
	"assets/icons/send.svg": 21614,
	"assets/icons/setting-2.svg": 17045,
	"assets/icons/setting-3.svg": 44436,
	"assets/icons/setting-4.svg": 54203,
	"assets/icons/setting-5.svg": 93834,
	"assets/icons/setting-6.svg": 85209,
	"assets/icons/settings.svg": 19179,
	"assets/icons/share.svg": 83029,
	"assets/icons/signpost.svg": 1837,
	"assets/icons/slash.svg": 34735,
	"assets/icons/slider.svg": 74819,
	"assets/icons/smart-home.svg": 28397,
	"assets/icons/sms-edit.svg": 76792,
	"assets/icons/sms-notification.svg": 91089,
	"assets/icons/sms-search.svg": 82512,
	"assets/icons/sms-star.svg": 64180,
	"assets/icons/sms-tracking.svg": 21743,
	"assets/icons/sms.svg": 79363,
	"assets/icons/sort.svg": 73272,
	"assets/icons/sound.svg": 85809,
	"assets/icons/speedometer.svg": 59235,
	"assets/icons/status.svg": 52978,
	"assets/icons/sticker.svg": 68217,
	"assets/icons/stickynote.svg": 36045,
	"assets/icons/stop-watch.svg": 48102,
	"assets/icons/story.svg": 9667,
	"assets/icons/tag-cross.svg": 3379,
	"assets/icons/tag-right.svg": 17581,
	"assets/icons/tag-user.svg": 95656,
	"assets/icons/task-square.svg": 65305,
	"assets/icons/task.svg": 42259,
	"assets/icons/tick-circle.svg": 81784,
	"assets/icons/tick-square.svg": 53153,
	"assets/icons/timer-pause.svg": 97102,
	"assets/icons/timer-start.svg": 48156,
	"assets/icons/timer.svg": 29767,
	"assets/icons/toggle-off-circle.svg": 96905,
	"assets/icons/toggle-off.svg": 16924,
	"assets/icons/toggle-on-circle.svg": 37667,
	"assets/icons/toggle-on.svg": 98662,
	"assets/icons/trash.svg": 74498,
	"assets/icons/tree.svg": 42492,
	"assets/icons/triangle.svg": 86008,
	"assets/icons/truck-go.svg": 8236,
	"assets/icons/truck-remove.svg": 30662,
	"assets/icons/truck-tick.svg": 15417,
	"assets/icons/truck-time.svg": 66069,
	"assets/icons/truck.svg": 78565,
	"assets/icons/trush-square.svg": 626,
	"assets/icons/undo.svg": 28854,
	"assets/icons/uo-empty.svg": 90352,
	"assets/icons/user-add.svg": 33103,
	"assets/icons/user-cirlce-add.svg": 67886,
	"assets/icons/user-edit.svg": 94806,
	"assets/icons/user-minus.svg": 30238,
	"assets/icons/user-octagon.svg": 83723,
	"assets/icons/user-remove.svg": 93150,
	"assets/icons/user-search.svg": 51682,
	"assets/icons/user-square.svg": 67983,
	"assets/icons/user-tag.svg": 53394,
	"assets/icons/user-tick.svg": 81745,
	"assets/icons/user.svg": 99709,
	"assets/icons/verify.svg": 99035,
	"assets/icons/warning-2.svg": 70701,
	"assets/icons/weight.svg": 89212,
	"assets/icons/wifi-square.svg": 30761,
	"assets/icons/wifi.svg": 61507,
	"assets/icons/wrench.svg": 99127,
	"assets/icons/xlsx-excel-thumb.svg": 34128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17105;